import React, { useState } from 'react';
import OrderPage from './components/OrderPage';
import { orderStatus } from '../../../constants/orderStatus';

const OutOfStock = () => {
  const bulkActionOptions = [
    {
      label: 'Assign',
      value: 'assign',
    },
    {
      label: 'Cancel',
      value: 'cancelOrder',
    },
  ];
  return (
    <div>
      <OrderPage
        type={orderStatus.outOfStock}
        bulkActionOptions={bulkActionOptions}
      />
    </div>
  );
};

export default OutOfStock;
